import React from "react";
import { Badge } from "@chakra-ui/react";
import {
  RISK_REVIEW_STATUS_CONFIG,
  RISK_REVIEW_TEMPLATE_STATUS_CONFIG,
  RISK_SEVERITY_CONFIG,
} from "../../constants/riskReviewStatuses";

const configs = {
  request: RISK_REVIEW_STATUS_CONFIG,
  template: RISK_REVIEW_TEMPLATE_STATUS_CONFIG,
  risk: RISK_SEVERITY_CONFIG,
};

const RiskReviewStatusBadge = ({ value, type = "request" }) => {
  const config = configs[type]?.[value] || {
    label: value || "Unknown",
    colorScheme: "gray",
  };

  return (
    <Badge
      colorScheme={config.colorScheme}
      borderRadius="full"
      px={2.5}
      py={0.5}
      fontSize="11px"
      textTransform="none"
      letterSpacing="0"
      whiteSpace="nowrap"
    >
      {config.label}
    </Badge>
  );
};

export default RiskReviewStatusBadge;
